import { Component, OnInit, Input } from '@angular/core';
import { CatalogService } from '@catalog/catalog.service';
import { DATA_PER_PAGE } from '@root/app.constant';

@Component({
  selector: 'app-catalogue-excel-list',
  templateUrl: './catalogue-excel-list.component.html',
  styleUrls: ['./catalogue-excel-list.component.scss'],
})
export class CatalogueExcelListComponent implements OnInit {
  @Input() data: any[];

  pageSize: number = DATA_PER_PAGE;

  constructor(private catalogService: CatalogService) {}

  ngOnInit() {}
}
